//image sizes for tmdb
export const img_300 = "https://rickandmortyapi.com/api/character/avatar";

// For Carousel
export const noPicture =
  "https://upload.wikimedia.org/wikipedia/en/6/60/No_Picture.jpg";
